import { Injectable, signal } from '@angular/core';

/** An OQ FDE (further verification) response, with the identifiers the agent needs for the verification call */
export interface FdeNotice {
  header: string;
  messageHtml: string;
  creditReferenceNumber: string;
  ban: string;
  /** Page-specific guidance shown under the identifiers, e.g. how to retry */
  note?: string;
}

/** Drives the FDE dialog in the order layout, so any order page can raise it */
@Injectable({ providedIn: 'root' })
export class FdeNoticeService {
  readonly #notice = signal<FdeNotice | null>(null);
  readonly notice = this.#notice.asReadonly();

  show(notice: FdeNotice) {
    this.#notice.set(notice);
  }

  close() {
    this.#notice.set(null);
  }
}
